document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.header--desktop');
  const searchResults = document.querySelector('#mcm-algolia-overlay');
  const announcementBar = document.querySelector('.announcement-bar');

  if (!header) return;

  const hasTransparentClass = header.classList.contains(
    'header--desktop-transparent'
  );

  if (!hasTransparentClass) return;

  function setHeaderHover() {
    header.classList.remove('header--desktop-transparent');
    header.classList.add('header--desktop-hover');
  }

  function removeHeaderHover() {
    header.classList.remove('header--desktop-hover');
    header.classList.add('header--desktop-transparent');
  }

  function searchIsOpen() {
    return !!(searchResults && searchResults.classList.contains('is-open'));
  }

  // Header / megamenu hover → solid white chrome
  header.addEventListener('mouseenter', function () {
    setHeaderHover();
  });

  header.addEventListener('mouseleave', function () {
    if (searchIsOpen()) return;
    removeHeaderHover();
  });

  // Search results hover
  if (searchResults) {
    searchResults.addEventListener('mouseenter', function () {
      setHeaderHover();
    });

    searchResults.addEventListener('mouseleave', function () {
      if (searchIsOpen()) return;
      removeHeaderHover();
    });
  }

  // Watch search open/close state
  if (searchResults && announcementBar) {
    const observer = new MutationObserver(function () {
      if (searchIsOpen()) {
        setHeaderHover();
        announcementBar.classList.add('search-active');
      } else {
        announcementBar.classList.remove('search-active');
        if (!header.matches(':hover')) removeHeaderHover();
      }
    });

    observer.observe(searchResults, {
      attributes: true,
      attributeFilter: ['class']
    });
  }
});
let lastScrollTop = 0;

window.addEventListener("scroll", function () {
  const scrollTop = window.scrollY;

  // At the very top
  if (scrollTop === 0) {
    document.body.classList.remove("scroll-back");
    lastScrollTop = 0;
    return;
  }

  // Scrolling up
  if (scrollTop < lastScrollTop) {
    document.body.classList.add("scroll-back");
  }

  // Scrolling down
  if (scrollTop > lastScrollTop) {
    document.body.classList.remove("scroll-back");
  }

  lastScrollTop = scrollTop;
});
document.addEventListener("click", function (event) {
  // Burger button
  if (event.target.closest(".burger__button")) {
    document.body.classList.toggle("menu-open");
  }

  // Drawer overlay
  if (event.target.closest(".drawer-v2__overlay")) {
    document.body.classList.remove("menu-open");
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const popup = document.querySelector('#EmailSignupPopup');
  const triggers = document.querySelectorAll('[data-email-popup-trigger]');
  const closeButtons = document.querySelectorAll('[data-email-popup-close]');

  if (!popup) return;

  const input = popup.querySelector('#EmailSignupPopupInput');

  function openPopup() {
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('email-popup-open');

    setTimeout(function () {
      if (input) input.focus();
    }, 250);
  }

  function closePopup() {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('email-popup-open');
  }

  // Open popup when a trigger is clicked
  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', openPopup);
  });

  // Close popup
  closeButtons.forEach(function (button) {
    button.addEventListener('click', closePopup);
  });

  // Close with Escape
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && popup.classList.contains('is-open')) {
      closePopup();
    }
  });

  // Keep popup open after successful newsletter submission
  if (popup.querySelector('.email-popup__message--success')) {
    openPopup();
  }

});
document.addEventListener('DOMContentLoaded', function () {
  const mobileBreakpoint = 749;

  document.querySelectorAll('.footer-menu').forEach(function (menu) {
    const heading = menu.querySelector('.footer-menu__heading');
    const links = menu.querySelector('.footer-menu__links');

    if (!heading || !links) return;

    heading.addEventListener('click', function () {
      if (window.innerWidth > mobileBreakpoint) return;

      menu.classList.toggle('is-open');
    });
  });
});